<div (click)="onContainerClicked($event)" class="basic modal fade  bg-card rounded-xl" [style.z-index]="1002" tabindex="-1" role="dialog" aria-hidden="true" [ngClass]="{'in': visibleAnimate}" [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}" [style]="customStyle">
  <div class="modal-dialog rounded-2xl h-full w-full mx-auto my-0" role="document" [ngClass]="dialogClass" [ngStyle]= "{ 'top': visibleTop ? visibleTop + 'px': 0}">
    <div class=" modal-content bg-card rounded-xl" style="border-radius: 12px">
      <div *ngIf="!hideHeader" class="modal-header bg-card ">
        <button type="button" class="close btn-close float-right" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <icon-times></icon-times>
        </button>
        <ng-content select=".app-modal-header"></ng-content>
      </div>
      <div class="modal-body bg-card py-4">
        <ng-content select=".app-modal-body"></ng-content>
      </div>
      <div *ngIf="!hideFooter" class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="hide()">{{'close'|translate}}</button>
        <ng-content select=".app-modal-footer"></ng-content>
      </div>
    </div>
  </div>
</div>
